import { usePageContextErrorBoundary } from "../../context/index";
import { Result } from "@/base/components/index";
import { ButtonLink } from "@/components/button-link/index";
import { LocalizationText } from "@/app/index";
import { usePageError500Styles } from "./page-error-500.styles";
import PageError500Svg from "../../static/page-error-500.svg?react";

export const PageError500 = () => {
  const { styles } = usePageError500Styles();
  const { localization } = usePageContextErrorBoundary();

  return (
    <Result
      className={styles.root}
      icon={<PageError500Svg />}
      title={<LocalizationText value="error.boundary.page.error.500.title" />}
      subTitle={
        <LocalizationText value="error.boundary.page.error.500.description" />
      }
      extra={
        <ButtonLink to={`/${localization.currentLang}/home`} type="primary">
          <LocalizationText value="error.boundary.page.error.500.button.text" />
        </ButtonLink>
      }
    />
  );
};
